module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.142a2e83.jpg";